import { ReduxRoot } from 'types/ReduxStore'

/**
 * Select the currently logged in user profile
 */
const userProfileCurrentSelector = (state: ReduxRoot) => state.userProfile

export default userProfileCurrentSelector
